import React, { useEffect, useState } from 'react'
import { useViewCaAllocationQuery, useViewSaldoQuery } from '../../../store/auth/authService'
import { Spinner, Typography } from '@material-tailwind/react'
import moment from 'moment'
import { useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppDispatch, RootState } from '../../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { setContractId, setServiceId } from '../../../store/service/contractSlice'
import TableLayout from '../../../layouts/pagesLayouts/TableLayout'
import FiltersSaldo from './FiltersSaldo'
import GraphSaldo from './GraphSaldo'
import { classCharContainerHeight, SALDO_GRAPH_ID } from '../common'
import { saveGraphToPicture } from '../../../utils/utils'
import axios from 'axios'
import { baseApi } from '../../../ConfigApi'
import { errorToast } from '../../../components/toasts/toasts'
import fileDownload from 'js-file-download'
import { SaldoFormType } from '../common.types'


const ViewSaldo = ({ setActiveDateCommon, activeDateCommon }: any) => {


    const { t } = useTranslation()

    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()

    const { token } = useSelector((state: RootState) => state.auth)
    const { or_number } = useSelector((state: RootState) => state.contract)

    const defaulPeriodFrom = moment().add(-6, 'month').format('MM-YYYY')
    const defaulPeriodTo = moment().format('MM-YYYY')

    const form: SaldoFormType = {
        contract_id: Number(param_contract_id) || 0,
        periodFrom: defaulPeriodFrom,
        periodTo: defaulPeriodTo,
        balance_id: 1,
    }

    const [sendForm, setSendForm] = useState<SaldoFormType>(form);

    const { currentData, error, isFetching } = useViewSaldoQuery<any>(sendForm)

    const allocationData = useViewCaAllocationQuery<any>({
        contract_id: Number(param_contract_id)
    })


    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(setContractId(Number(param_contract_id)))
    }, [param_contract_id]);


    const setFormForFetch = (values: any) => {
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    const saveExcel = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-12`, {
            ...sendForm,
            typeReport: 12,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_12')} ${sendForm.periodFrom}-${sendForm.periodTo}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    return (
        <div>

            <Typography variant='lead' className='text-gray-800 mb-[24px] tab:mb-[32px] text-[24px] lap:text-[32px] font-medium leading-[1.2]'>
                {t('analytics.analytics_saldo_title')}
            </Typography>
            <FiltersSaldo
                activeDateCommon={activeDateCommon}
                setActiveDateCommon={setActiveDateCommon}
                value={{
                    periodFrom: sendForm.periodFrom,
                    periodTo: sendForm.periodTo,
                    balance_id: sendForm.balance_id
                }}
                isLoadingFetch={isFetching}
                fetchPage={setFormForFetch}
                savePicture={() => {
                    saveGraphToPicture(SALDO_GRAPH_ID, `${t('or')} ${or_number} - ${t('analytics.analytics_saldo_title')} ${t('by_period')} ${sendForm.periodFrom} - ${sendForm.periodTo}.png`)
                }}
                saveExcel={saveExcel}
                isAllocation={!!allocationData?.currentData}
            />
            {

                currentData?.formatted ?
                    <>
                        <div className='bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px]'>
                            <Typography variant='lead' className='text-gray-800 mb-[12px] lap:mb-[24px] text-[20px] lap:text-[24px] font-medium'>
                                {t('analytics.analytics_saldo_subtitle')}
                            </Typography>
                            <div className={classCharContainerHeight}>
                                <GraphSaldo
                                    data={currentData.formatted}
                                />
                            </div>
                        </div>
                    </>
                    :
                    isFetching ?
                        <div className={`bg-white border-2 border-gray-200 rounded-[24px] p-[32px] ${classCharContainerHeight} flex justify-center items-center`}>
                            <Spinner />
                        </div>
                        :
                        error ?
                            <TableLayout>
                                <Typography variant='lead' className='text-[20px] font-medium text-center my-[40px]'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                            </TableLayout>
                            :
                            ''
            }

        </div>
    )
}

export default ViewSaldo